// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1XUzq","title":"Info_title__1mYvL","links":"Info_links__2woK8","link":"Info_link__1P10e","logo":"Info_logo__2rwqC"};